import { useEffect, useState } from 'react'
import { Alert, Col, Collapse, Row } from 'react-bootstrap'
import PageSelector from './PageSelector'
import InputForm from './InputForm'
import {
  AiFillCheckSquare,
  AiOutlineCheckSquare,
  AiOutlineClose,
  AiFillCaretDown,
  AiFillCaretUp,
} from 'react-icons/ai'
import BookNowForm from './Teachers/BookNowForm'
import { TailSpin } from 'react-loader-spinner'
import TeacherCard from './Teachers/TeacherCard'
import Verfied from '../assets/assets/Verified.svg'
import Student from '../assets/assets/Student.svg'
import Rate from '../assets/assets/Rate.svg'
import Teacher from '../assets/assets/Teacher.svg'
import './TableStyle.css'

function Page({
  ListName = 'List of teachers',
  Data,
  formSubmitHandler,
  inputs,
  ActionName,
  error,
  ShowForm,
  FormShown,
  loader,
  teachers,
  teacherLoader,
  fetchTeacherData,
  paginationData = null,
  successMessage,
  setSuccessMessage,
  applyFilter,
}) {
  const [selectedPage, setSelectedPage] = useState(1)
  const [selectedTeacher, setSelectedTeacher] = useState()
  const AddItem = () => {
    ShowForm(true)
  }
  const [Stats] = useState([
    {
      Name: 'Users',
      Data: '17k +',
      Desc: 'Monthly Users',
      img: Verfied,
    },
    {
      Name: 'Students',
      Data: '17k +',
      Desc: 'Total Register Students',
      img: Student,
    },
    {
      Name: 'Teachers',
      Data: '17k +',
      Desc: 'Total Register Teachers',
      img: Teacher,
    },
    {
      Name: 'Rate',
      Data: '98%',
      Desc: 'Total Open Rate',
      img: Rate,
    },
  ])
  const [showBookNow, setShowBookNow] = useState(false)
  const [search, setSearch] = useState('')
  const [filters, setFilters] = useState({
    'Job Type': [
      { name: 'Banker', selected: false },
      { name: 'Business Personnel', selected: false },
      { name: 'Designer', selected: false },
      { name: 'E-commerce', selected: false },
      { name: 'Education', selected: false },
      { name: 'Engineer', selected: false },
      { name: 'Engineering and Construction', selected: false },
      { name: 'Entertainment and Media', selected: false },
      { name: 'Environmental Conservation', selected: false },
      { name: 'Finance', selected: false },
      { name: 'Freelancer', selected: false },
      { name: 'Hospitality and Tourism', selected: false },
      { name: 'Sustainability & Renewable Energy', selected: false },
      { name: 'Technology', selected: false },
      { name: 'Other', selected: false },
    ],
    Mode: [
      { name: 'Face-To-Face', selected: false },
      { name: 'Online', selected: false },
    ],
    Availability: [
      { name: 'Sunday', selected: false },
      { name: 'Monday', selected: false },
      { name: 'Tuesday', selected: false },
      { name: 'Wednesday', selected: false },
      { name: 'Thursday', selected: false },
      { name: 'Friday', selected: false },
      { name: 'Saturday', selected: false },
    ],
    'Time Slot': [
      { name: '9AM-12PM', selected: false },
      { name: '12PM-3PM', selected: false },
      { name: '3PM-6PM', selected: false },
      { name: '6PM-9PM', selected: false },
    ],
    Emirates: [
      { name: 'Abu Dhabi', selected: false },
      { name: 'Dubai', selected: false },
      { name: 'Sharjah', selected: false },
      { name: 'Umm Al Quwain', selected: false },
      { name: 'Ajman', selected: false },
      { name: 'Ras al Khaimah', selected: false },
      { name: 'Fujairah', selected: false },
      { name: 'London', selected: false },
    ],
  })
  const [showFilters, setShowFilter] = useState(false)
  useEffect(() => {}, [selectedPage])

  const handlePageSelect = async (page) => {
    try {
      if (selectedPage !== page) {
        setSelectedPage(page)
        await applyFilter({ search, filters }, page)
      }
    } catch (error) {
      console.log()
      alert('An error occured please try after some time')
    }
  }

  const searchHandler = (e) => {
    if (e.target.value.match(/^[a-zA-Z0-9]*$/)) {
      setSearch(e.target.value)
      setSelectedPage(1)
      applyFilter({ search: e.target.value, filters }, 1)
    }
  }

  const filterHandler = ({ type, name }) => {
    const updatedFilterByName = filters[type].map((filter) => ({
      ...filter,
      selected: filter.name === name ? !filter.selected : filter.selected,
    }))
    const updatedFilters = {
      ...filters,
      [type]: updatedFilterByName,
    }
    setSelectedPage(1)
    applyFilter({ search, filters: updatedFilters }, 1)
    setFilters(updatedFilters)
  }
  return (
    <div className='container' style={{ minHeight: '90vh' }}>
      <div className='guest-lacture-page'>
        <div>
          <Row xs={1} md={2} lg={4} className='STATS'>
            {Stats.map((e, index) => (
              <Col key={index}>
                <div className='stats-card'>
                  <div className='stats-img'>
                    <img src={e.img} alt={e.Name} />
                  </div>
                  <div className='stats-text'>
                    <p
                      className='text-2xl font-semibold'
                      style={{ marginBottom: 0, color: '#4c9a3a' }}
                    >
                      {e.Data}
                    </p>
                    <p style={{ marginBottom: 0, color: '#008ecf' }}>
                      {e.Desc}
                    </p>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
          {successMessage && (
            <Alert variant='success' style={{ marginTop: 30 }}>
              {successMessage}
              <AiOutlineClose
                style={{ float: 'right', cursor: 'pointer' }}
                onClick={() => setSuccessMessage('')}
              />
            </Alert>
          )}
          {/* Your DATA TABLE HERE (You can edit first Collumn it's id by default) */}
          <div
            className='d-flex w-100'
            style={{ justifyContent: 'space-between', marginTop: 30 }}
          >
            <p
              className='font-semibold'
              style={{
                fontSize: '24px',
                fontWeight: 'bold',
                color: 'green',
              }}
            >
              {ListName}
            </p>
            <button className='RegButton' onClick={() => AddItem()}>
              Register
            </button>
          </div>
          <Row style={{ marginTop: 30 }}>
            <Col md={3}>
              <div className='teacher-search-container'>
                <input
                  className='teacher-search-input'
                  name='search'
                  placeholder='Search'
                  value={search}
                  onChange={searchHandler}
                />
                <div className='teacher-filter-container'>
                  <p
                    style={{
                      color: 'green',
                      fontWeight: 'bold',
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      cursor: 'pointer',
                      marginBottom: 0,
                      marginTop: -3,
                    }}
                    onClick={() => setShowFilter((prev) => !prev)}
                  >
                    Apply Filters:
                    <i className='open-filters-icon' style={{ fontSize: 22 }}>
                      {showFilters ? <AiFillCaretDown /> : <AiFillCaretUp />}
                    </i>
                  </p>
                  <Collapse in={showFilters}>
                    <div>
                      {Object.keys(filters).map((name) => (
                        <div key={name}>
                          <p>{name}</p>
                          {filters[name].map((filter) => (
                            <p
                              key={filter.name}
                              className={`availability ${
                                filter.selected ? 'selected' : 'not-selected'
                              }`}
                              onClick={() =>
                                filterHandler({ type: name, name: filter.name })
                              }
                            >
                              {!filter.selected && (
                                <AiOutlineCheckSquare
                                  fontSize={20}
                                  style={{ marginRight: 10 }}
                                />
                              )}
                              {filter.selected && (
                                <AiFillCheckSquare
                                  fontSize={20}
                                  style={{ marginRight: 10 }}
                                />
                              )}
                              {filter.name}
                            </p>
                          ))}
                        </div>
                      ))}
                    </div>
                  </Collapse>
                </div>
              </div>
            </Col>
            <Col md={9}>
              {teacherLoader && (
                <div
                  style={{
                    width: '100%',
                    marginTop: '4rem',
                    marginBottom: '4rem',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <TailSpin
                    height='50'
                    width='50'
                    color='#4fa94d'
                    ariaLabel='tail-spin-loading'
                    radius='1'
                    wrapperStyle={{
                      backgroundColor: '#fff',
                      padding: 20,
                      borderRadius: 5,
                    }}
                    visible={true}
                  />
                </div>
              )}
              {!teacherLoader && (
                <div className='TableContainer'>
                  <Row className='teacher-card-row'>
                    <Col md={12}>
                      {teachers.length <= 0 && (
                        <Alert variant='success'>No Teacher Found</Alert>
                      )}
                      {teachers.map((teacher) => (
                        <TeacherCard
                          key={teacher.id}
                          setShowBookNow={setShowBookNow}
                          setSelectedTeacher={setSelectedTeacher}
                          teacher={teacher}
                        />
                      ))}
                    </Col>
                  </Row>
                </div>
              )}
            </Col>
          </Row>
        </div>
      </div>
      {/* The Pagination Select Carousel */}
      {paginationData && (
        <div className='flex' style={{ marginBottom: 50, marginTop: 30 }}>
          <PageSelector
            totalPages={paginationData.last_page}
            selectedPage={selectedPage}
            handlePageSelect={handlePageSelect}
          ></PageSelector>
        </div>
      )}
      {/* Our Submission Form , You Can Set The Data that You want to add it to  */}
      {FormShown && (
        <InputForm
          ShowForm={ShowForm}
          inputs={inputs}
          Data={Data}
          formSubmitHandler={formSubmitHandler}
          ActionName={ActionName}
          error={error}
          loader={loader}
        ></InputForm>
      )}
      {/* Book Now Form */}
      {showBookNow && (
        <BookNowForm setShow={setShowBookNow} teacherId={selectedTeacher} />
      )}
    </div>
  )
}
export default Page
